import React, { useEffect, useState } from 'react';
import { components } from '../components';
import { useLocation, useNavigate } from 'react-router-dom';
import { callService } from '../customHook/callService';
import { text } from '../text';
import { theme } from '../constants';

export const HelpCenter: React.FC = () => {
    const { pathname } = useLocation();
    const [selectedLoan, setSelectedLoan] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const loanItems = [
        {
            title: 'VIEW HELP CENTER',
            image: require('../assets/other/view_help_center.png'),
            link: "/profile/help-and-support"
        },
        {
            title: 'Privacy Policy',
            image: require('../assets/other/privacyPolicy.png'),
            link: "/profile/privacy-policy"
        },
        {
            title: 'Terms and Conditions',
            image: require('../assets/other/terms_&_conditions2.png'),
            link: "/terms-conditions"

        },
    ];


const handleImageClick = async (title: string, link: string) => {
    console.log(`Image clicked: ${title}`);
    try {
        const res = await callService('Banner', [
            {
                param: 'Banner',
                value: title,
            },
        ]);
        setSelectedLoan(title);
    } catch (error) {
        setSelectedLoan(title);
        console.error(`❌ CLICK_BANNER failed for "${title}"`, error);
    }
    navigate(link);
};


    return (
        <>
            <components.Header title="Help Center" goBack={true} />
            <main className="container">
                <div style={{ marginTop: '10%', marginBottom: 40 }}>
                    {/* <h2 style={{ textAlign: 'center', marginBottom: 20, fontWeight: "600" }}>Choose the Right Loan for You</h2> */}

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
                        {loanItems.map((item, index) => (
                            <div
    key={index}
    style={{
        border: '1px solid #eee',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        textAlign: 'center',
        cursor: 'pointer',
    }}
    onClick={() => handleImageClick(item.title, item.link)}
>
    <img
        src={item.image}
        alt={item.title}
        style={{
            width: '100%',
            height: 'auto',
            borderRadius: '8px',
            transition: 'transform 0.2s',
        }}
    />
</div>

                        ))}
                    </div>
                </div>
            </main>
        </>
    );
};






// import React, { useEffect, useState } from 'react';
// import { components } from '../components';
// import { useLocation } from 'react-router-dom';
// import { callService } from '../customHook/callService';
// import { text } from '../text';
// import { theme } from '../constants';

// export const HelpCenter: React.FC = () => {
//     const { pathname } = useLocation();
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [isModalOpen2, setIsModalOpen2] = useState(false);
//     const [selectedLoan, setSelectedLoan] = useState('');

//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);

//     const loanItems = [
//         {
//             title: 'VIEW HELP CENTER',
//             image: require('../assets/other/view_help_center.png'),
//             link: "/profile/help-and-support"
//         },
//         {
//             title: 'Privacy Policy',
//             image: require('../assets/other/privacyPolicy.png'),
//             link: "/profile/privacy-policy"
//         },
//         {
//             title: 'Terms and Conditions',
//             image: require('../assets/other/terms_&_conditions2.png'),
//             link: "/terms-conditions"

//         },
//     ];


//     const handleImageClick = async (title: string) => {
//         console.log(`Image clicked: ${title}`);
//         try {
//             const res = await callService('Banner', [
//                 {
//                     param: 'Banner',
//                     value: title,
//                 },
//             ]);
//             setSelectedLoan(title);
//             setIsModalOpen(true);
//         } catch (error) {
//             setSelectedLoan(title); // ✅ still show message even on error
//             setIsModalOpen2(true);
//             // setIsModalOpen(true);
//             console.error(`❌ CLICK_BANNER failed for "${title}"`, error);
//         }
//     };

//     return (
//         <>
//             <components.Header title="Help Center" goBack={true} />
//             <main className="container">
//                 <div style={{ marginTop: '10%', marginBottom: 40 }}>
//                     {/* <h2 style={{ textAlign: 'center', marginBottom: 20, fontWeight: "600" }}>Choose the Right Loan for You</h2> */}

//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
//                         {loanItems.map((item, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     border: '1px solid #eee',
//                                     borderRadius: '8px',
//                                     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
//                                     textAlign: 'center',
//                                     cursor: 'pointer',
//                                 }}
//                                 onClick={() => handleImageClick(item.title)}
//                             >
//                                 <img
//                                     src={item.image}
//                                     alt={item.title}
//                                     style={{
//                                         width: '100%',
//                                         height: 'auto',
//                                         borderRadius: '8px',
//                                         // marginBottom: 16,
//                                         transition: 'transform 0.2s',
//                                     }}
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {isModalOpen && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <div
//                                 style={{
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                 }}
//                             >
//                                 {/* <img
//                                     alt='Success'
//                                     src={require('../assets/other/04.png')}
//                                     style={{ width: '50%', height: 'auto', marginBottom: 10 }}
//                                 /> */}
//                                 {/* <span
//                                                                     style={{
//                                                                         ...theme.fonts.LeagueSpartan_500Medium,
//                                                                         fontSize: 12,
//                                                                         color: theme.colors.mainColor,
//                                                                     }}
//                                                                 >
//                                                                     Nuton
//                                                                 </span> */}
//                                 <img
//                                     alt='Success'
//                                     // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
//                                     src={require('../assets/other/check.png')}
//                                     style={{ width: '30%', height: 'auto', margin: "30px 0" }}
//                                 />
//                                 {/* <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
//                                     ✅ Request Sent Successfully
//                                 </h2> */}
//                                 <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
//                                     Interest Registered for: <div>{selectedLoan}</div>
//                                 </p>
//                                 <text.T14
//                                     style={{
//                                         whiteSpace: 'pre-line',
//                                         textAlign: 'center',
//                                         marginBottom: 24,
//                                     }}
//                                 >
//                                     Thank you! Our team will contact you soon.
//                                 </text.T14>
//                                 <div
//                                     onClick={() => {
//                                         setIsModalOpen(false)
//                                     }}
//                                     style={{
//                                         width: '100%',
//                                         color: theme.colors.white,
//                                         height: 40,
//                                         textAlign: 'center',
//                                         fontSize: 14,
//                                         borderRadius: 10,
//                                         userSelect: 'none',
//                                         cursor: 'pointer',
//                                         textTransform: 'capitalize',
//                                         background: "#000000d1",
//                                         fontFamily: 'Lato-Bold',
//                                         marginTop: 12, // optional spacing
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center"
//                                     }}
//                                 >
//                                     Continue
//                                 </div>
//                             </div>
//                             {/* <div className="modal-buttons">
//                                                 <button
//                                                     type="button"
//                                                     className="cancel-button"
//                                                     onClick={() => setIsModalOpen2(false)}
//                                                 >
//                                                     Thank You
//                                                 </button>
                
//                                             </div> */}
//                         </div>
//                     </div>
//                 )}




//                 {isModalOpen2 && (
//                     <div className="modal-overlay">
//                         <div className="modal-content">
//                             <div
//                                 style={{
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                 }}
//                             >
//                                 <img
//                                     alt='Success'
//                                     src={require('../assets/other/04.png')}
//                                     style={{ width: '50%', height: 'auto', marginBottom: 10 }}
//                                 />
//                                 {/* <span
//                                                                     style={{
//                                                                         ...theme.fonts.LeagueSpartan_500Medium,
//                                                                         fontSize: 12,
//                                                                         color: theme.colors.mainColor,
//                                                                     }}
//                                                                 >
//                                                                     Nuton
//                                                                 </span> */}
//                                 <img
//                                     alt='Success'
//                                     // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
//                                     src={require('../assets/other/warning.png')}
//                                     style={{ width: '25%', height: 'auto', margin: "30px 0" }}
//                                 />
//                                 <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
//                                     Something Went Wrong
//                                 </h2>
//                                 <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
//                                     We couldn't process your request.
//                                 </p>
//                                 <text.T14
//                                     style={{
//                                         whiteSpace: 'pre-line',
//                                         textAlign: 'center',
//                                         marginBottom: 24,
//                                     }}
//                                 >
//                                     Please try again later. If the issue persists, contact our support team.
//                                 </text.T14>
//                                 <div
//                                     onClick={() => {
//                                         setIsModalOpen2(false)
//                                     }}
//                                     style={{
//                                         width: '100%',
//                                         color: theme.colors.white,
//                                         height: 40,
//                                         textAlign: 'center',
//                                         fontSize: 14,
//                                         borderRadius: 10,
//                                         userSelect: 'none',
//                                         cursor: 'pointer',
//                                         textTransform: 'capitalize',
//                                         background: "#000000d1",
//                                         fontFamily: 'Lato-Bold',
//                                         marginTop: 12, // optional spacing
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center"
//                                     }}
//                                 >
//                                     Continue
//                                 </div>
//                             </div>
//                             {/* <div className="modal-buttons">
//                                                 <button
//                                                     type="button"
//                                                     className="cancel-button"
//                                                     onClick={() => setIsModalOpen2(false)}
//                                                 >
//                                                     Thank You
//                                                 </button>
                
//                                             </div> */}
//                         </div>
//                     </div>
//                 )}
//             </main>
//         </>
//     );
// };


